import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const SubscribeForm = ({ t, lang, source, buttonLabel, idPrefix = "hero" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!EMAIL_RE.test(value)) {
      toast.error(t.formInvalid);
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/subscribe`, { email: value, lang, source });
      setDone(true);
      setEmail("");
      toast.success(t.formSuccess);
    } catch (err) {
      if (err?.response?.status === 409) {
        toast(t.formExists);
        setDone(true);
      } else {
        toast.error(t.formError);
      }
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <p
        data-testid={`${idPrefix}-subscribe-success`}
        className="font-serif italic text-xl text-ink/70 py-2"
      >
        {t.formSuccess}
      </p>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid={`${idPrefix}-subscribe-form`}
      className="flex flex-col sm:flex-row items-stretch sm:items-end gap-5 sm:gap-8 w-full max-w-[560px]"
    >
      <div className="flex-1">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t.formPlaceholder}
          data-testid={`${idPrefix}-email-input`}
          className="w-full bg-transparent border-b border-ink/25 focus:border-ink/70 outline-none pb-3 text-lg text-ink placeholder:text-ink-faint transition-colors duration-500"
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid={`${idPrefix}-submit-button`}
        className="group inline-flex items-center gap-2 whitespace-nowrap text-sm tracking-wide text-ink/70 hover:text-ink pb-2 disabled:opacity-50 transition-colors duration-500"
      >
        {loading ? "…" : buttonLabel}
        <ArrowRight
          size={16}
          className="transition-transform duration-500 group-hover:translate-x-1.5"
        />
      </button>
    </form>
  );
};
